{
    "Accessibility menu": "Menu accessibilità",
    "Reset settings": "Ripristina impostazioni",
    "Close": "Chiudi",
    "Content adjustments": "Regolazioni Contenuto",
    "Navigation adjustments": "Regolazioni Navigazione",
    "Align Left": "Allinea a Sinistra",
    "Adjust Font Size": "Regola Dimensione Carattere",
    "Highlight Title": "Evidenzia Titolo",
    "Highlight Links": "Evidenzia Collegamenti",
    "Readable Font": "Carattere Leggibile",
    "Colour adjustments": "Regolazioni Colore",
    "Dark Contrast": "Contrasto Scuro",
    "Light Contrast": "Contrasto Chiaro",
    "High Contrast": "Alto Contrasto",
    "High Saturation": "Alta Saturazione",
    "Low Saturation": "Bassa Saturazione",
    "Monochrome": "Monocromatico",
    "Tools": "Strumenti",
    "Reading Guide": "Guida alla Lettura",
    "Stop Animations": "Ferma Animazioni",
    "Big Cursor": "Cursore Grande",
    "Increase Font Size": "Aumenta Dimensione Carattere",
    "Decrease Font Size": "Diminuisci Dimensione Carattere",
    "Letter Spacing": "Spaziatura Lettere",
    "Line Height": "Altezza Riga",
    "Font Weight": "Spessore Carattere",
    "Dyslexia Font": "Carattere per Dislessia",
    "Language": "Lingua",
    "Accessibility widget": "Apri menu accessibilità",
    "Accessibility Profiles": "Profili di Accessibilità",
    "Cognitive Disability": "Disabilità Cognitiva",
    "Seizure Safe": "Sicuro per Epilessia",
    "Accessibility statement": "Dichiarazione di Accessibilità"
}